<template>
  <Section id="trust" tone="default" pad-y="md">
    <Container>
      <div class="flex flex-col gap-8">
        <div class="flex flex-col gap-3 md:max-w-2xl">
          <h2 class="text-2xl font-extrabold text-ink-strong md:text-3xl">
            {{ t('sections.trust.title') }}
          </h2>
          <p class="text-base text-ink-muted">{{ t('sections.trust.subtitle') }}</p>
        </div>
        <StatsBlock :items="localizedStats" size="large" />
        <ul class="flex flex-wrap gap-2">
          <li v-for="cert in certifications" :key="cert">
            <BaseBadge tone="accent" size="xl">
              <span class="px-1">{{ cert }}</span>
            </BaseBadge>
          </li>
        </ul>
      </div>
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import StatsBlock from '@/components/domain/StatsBlock.vue';
import BaseBadge from '@/components/base/BaseBadge.vue';
import { TRUST_STATS, type StatItem } from '@/content/home-data';
import { useLocale } from '@/composables/useLocale';
import { pickLocalized } from '@/lib/i18n/localize';

const { t } = useI18n();
const { locale } = useLocale();

const CERTIFICATIONS_RU = [
  'ISO 9001:2015',
  'АРПП «Отечественный Софт»',
  'Запатентованная технология',
] as const;

const CERTIFICATIONS_EN = [
  'ISO 9001:2015',
  'ARPP "Russian Software"',
  'Patented technology',
] as const;

const certifications = computed(() =>
  locale.value === 'en' ? CERTIFICATIONS_EN : CERTIFICATIONS_RU,
);

const localizedStats = computed(() =>
  TRUST_STATS.map((s): StatItem => ({ ...s, label: pickLocalized(s, 'label', locale.value) })),
);
</script>
